import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import { RISK_LEVEL_OPTIONS } from 'utils/constants/risks';

export const filters = (userAssignedDepartments = []) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);

  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'riskLevel',
        field: 'risk',
        type: 'select',
        options: RISK_LEVEL_OPTIONS,
      },
    ],
    AdvancedFilters: [...departmentFilterField],
  };
};
